"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _Dropdown = _interopRequireDefault(require("./Dropdown.style"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var renderAnchor = function renderAnchor(item, itemId, itemsProps, closeMenu) {
  return R.path([item.key, 'disabled'], itemsProps) ? /*#__PURE__*/_react["default"].createElement("span", _extends({
    className: "list-menu-item disabled"
  }, itemsProps[item.key]), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "item-icon",
    icon: item.icon,
    size: 24,
    id: "linkIcon_".concat(itemId, "_").concat(item.key)
  }), item.name) : /*#__PURE__*/_react["default"].createElement("a", _extends({
    className: "list-menu-item",
    href: item.link,
    onClick: R.compose(closeMenu, function () {
      return item.onClick(itemId);
    })
  }, itemsProps[item.key]), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "item-icon",
    icon: item.icon,
    size: 24,
    id: "linkIcon_".concat(itemId, "_").concat(item.key)
  }), item.name);
};
var Dropdown = function Dropdown(_ref) {
  var items = _ref.items,
    itemId = _ref.itemId,
    itemsProps = _ref.itemsProps,
    optionsTracking = _ref.optionsTracking,
    closeMenu = _ref.closeMenu;
  return /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
    className: "list-menu"
  }, /*#__PURE__*/_react["default"].createElement("ul", null, items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      role: "presentation",
      key: item.name,
      onKeyDown: function onKeyDown() {
        if (!R.path([item.key, 'disabled'], itemsProps)) optionsTracking(item.name, itemId);
      },
      onClick: function onClick() {
        if (!R.path([item.key, 'disabled'], itemsProps)) optionsTracking(item.name, itemId);
      }
    }, item.routerLinkBase && itemId ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, _extends({
      to: "".concat(item.routerLinkBase, "/").concat(itemId)
    }, itemsProps[item.key]), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      className: "item-icon",
      icon: item.icon,
      size: 24,
      id: "routeItemIcon_".concat(itemId)
    }), item.name) : renderAnchor(item, itemId, itemsProps, closeMenu));
  })));
};
Dropdown.propTypes = {
  closeMenu: _propTypes["default"].func,
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    icon: _propTypes["default"].string,
    itemId: _propTypes["default"].number,
    link: _propTypes["default"].string,
    routerLinkBase: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    props: _propTypes["default"].shape({
      disabled: _propTypes["default"].bool
    })
  })).isRequired,
  itemId: _propTypes["default"].string,
  optionsTracking: _propTypes["default"].func,
  itemsProps: _propTypes["default"].shape({})
};
Dropdown.defaultProps = {
  closeMenu: function closeMenu() {},
  itemId: '',
  itemsProps: {},
  optionsTracking: function optionsTracking() {}
};
var _default = exports["default"] = Dropdown;